<template>
	 <v-container fluid>
	 	<v-card class = "card-curvey">
      	<v-layout 
          row 
          wrap>
          <h2>Message</h2>
        </v-layout>
        <v-flex xs12>
          <v-spacer />
          <v-btn-toggle v-model="message.type" style="width: 100%" @change="message.message=null">
                <v-spacer />
                <v-btn value="text" style = "border-radius: 8px; margin-right: 10px; width: 100px !important; height: 35px;">
                    Text
                </v-btn>
                <v-btn value="block" style = "border-radius: 8px; width: 100px !important; height: 35px;">
                    Blocks
                </v-btn>
            </v-btn-toggle>
             <v-autocomplete
                v-if="message.type === 'block'"
                v-model="message.message"
                :items="blocks"
                item-text="name"
                chips
                return-object
                outline
                solo
                @input="message.message = $event.id" />
        <v-textarea
            v-model="message.message"
            v-if="message.type === 'text'"
            outline
        />
        </v-flex>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="handleMessageChange">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
   </v-layout>
</v-container>
</template>

<script>
import common from "../../utils/common";
import replay from "../ai/replays";
export default {

  name: 'BroadcastReplies',
  components: {
  	replay
  },
  data () {
    return {
    	blocks: [],
    	message: {
        type: 'text',
        message: ''
      }
    }
  },
  mounted() {
  	this.getBlockList()
    this.getMessage()
  },
  methods: {
  	getBlockList () {
        this.$store.dispatch('setLoader',true)
        this.$http_bot.get('/blocks')
          .then(response=>{
            this.blocks = response.data
            this.$store.dispatch('setLoader',false)
          })
          .catch(error=>{
            this.$store.dispatch('setLoader',false)
            if (error.response && error.response.status === 401) {
              common.logOut()
            } else {
              this.$store.dispatch('setErrorMessage', true)
            }
          })
      },
      getMessage() {
        this.$store.dispatch('setLoader',true)
        this.$http_chat.get(`/broadcasts/${this.$route.params.id}/message`).then(res => {
          this.$store.dispatch('setLoader',false)
          this.message =  this.$_.pick(res.data.data, ['message', 'type'])
        }).catch(()=>{
          this.$store.setErrorMessage(true)
          this.$store.dispatch('setLoader',false)
        })
      },
      handleMessageChange() {
        const payload = this.message
        this.$store.dispatch('setLoader',true)
        this.$http_chat.put(`/broadcasts/${this.$route.params.id}/message`, payload).then(()=>{
          this.$store.dispatch('setLoader',false)
          this.$store.dispatch('setSnackbar', {
            text: `Updated Successfully`,
            color: 'success'
          })
        }).catch(()=>{
          this.$store.setErrorMessage(true)
          this.$store.dispatch('setLoader',false)
        })
      }
  }
}
</script>

<style lang="css">
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 0;
        margin-top: -10px;
    }
</style>